export default "__VITE_ASSET__DrKIAUiq__"